import { createRootRoute, Link } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { MapPinOff } from 'lucide-react';
import { AppShell } from '../components/AppShell';
import { Button } from '../components/ui/button';

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 text-center space-y-5">
      <div className="w-16 h-16 rounded-full bg-brand-soft grid place-items-center text-brand">
        <MapPinOff className="h-8 w-8" />
      </div>
      <div>
        <h1 className="text-page font-extrabold text-ink">Page introuvable</h1>
        <p className="text-ink-mute text-body mt-2 max-w-xs mx-auto">
          Cette page n'existe pas ou a été déplacée. Vérifiez l'URL ou retournez au tableau de bord.
        </p>
      </div>
      <Link to="/dashboard">
        <Button>Retour au dashboard</Button>
      </Link>
    </div>
  );
}

export const Route = createRootRoute({
  component: () => (
    <>
      <AppShell />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  ),
  notFoundComponent: NotFound,
});
